import e from"styled-components";import{theme as r}from"../../../theme.js";const o=t=>{switch(t){case"bottom":return"-100%";case"center":return"-50%";case"top":return"0%";default:return"-100%"}},n=t=>{switch(t){case"right":return"-100%";case"center":return"-50%";case"left":return"0%";default:return"-100%"}},i=t=>{switch(t){case"bottom":return"100%";case"center":return"50%";case"top":return"0%";default:return"100%"}},a=t=>{switch(t){case"right":return"100%";case"center":return"50%";case"left":return"0%";default:return"0%"}};e.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  z-index: 1001;
`,e.div`
  width: 100%;
  height: 100%;
  background-color: #00000099;
`;const c=e.div`
  position: relative;
  width: fit-content;
  height: fit-content;
`,s=e.button`
  border: none;
  outline: none;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  border-radius: 50%;
  background-color: transparent;
  transition: all .1s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${r.colors.gray[400]}
    }
  }
  &:hover {
    background-color: ${r.colors.gray[200]};
    > svg {
      > g, path {
        fill: ${r.colors.gray[500]};
      }
    }
  }
`,d=e.button`
  width: fit-content;
  height: fit-content;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: unset;
  display: flex;
  align-items: center;
  justify-content: center;
`,l=e.div`
  position: absolute;
  background-color: ${r.colors.shades[0]};
  z-index: 1002;
  padding: ${r.spacing*4}px;
  border-radius: ${r.radius}px;
  min-width: 250px;
  box-shadow: ${r.boxShadow};
  left: ${({anchorOrigin:t})=>a(t.horizontal)};
  top: ${({anchorOrigin:t})=>i(t.vertical)};
  transform: ${({transformOrigin:t})=>`translate(${n(t.horizontal)}, ${o(t.vertical)})`};
`,u=e.button`
  font-size: 16px;
  color: ${r.colors.gray[800]};
  border: none;
  padding: 0;
  background-color: unset;
  display: block;
  padding: ${r.spacing*3}px;
  border-radius: ${r.radius}px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  &.with-icon {
    display: grid;
    grid-template-columns: 20px 1fr;
    grid-column-gap: ${r.spacing*2}px;
    align-items: center;
    > svg {
      width: 20px;
      height: 20px;
      > g, path {
        fill: ${r.colors.gray[800]};
      }
    }
  }
  &:hover {
    background-color: ${r.colors.gray[100]};   
  }
`;export{u as Button,c as Container,l as Content,s as MoreButton,d as MoreButtonAdditional};
